<template>
  <div>

    <div class="col-md-12">
      <div class="mb-1 d-flex w-100 justify-content-between">
        <span class="text-blue me-1">{{ $t(material.activitat_assignatures[0]) }}</span>
        <span class="text-secondary">
          <span v-if="material.activitat_subtipus_docencia == 'assignaturesCoordinades'" class="badge bg-gradient bg-warning">{{$t('Coordinador')}}</span>
        </span>
      </div>

      <div class="text-upc-green fw-bolder mb-1">{{$t(material.activitat_subtipus_docencia)}}</div>

      <span class="text-secondary flex-shrink-0 me-3">
        {{ material.data }}/{{ parseInt(material.data)+1 }}
        <span class="badge rounded-pill ms-1" :class="material.activitat_quadrimestre === '1' ? 'bg-primary' : 'bg-secondary'">
          Q{{ material.activitat_quadrimestre }}
        </span>
      </span>

    </div>
  </div>
</template>


<script>

import {imageUrlAlt} from "@/utils/utils";

export default {

  name: "ItemListDocenciaImpartida",
  methods: {imageUrlAlt},
  props: {
    material: Object,
    index: Number
  },
  setup() {

    const hideShow = (index) => {
      const element = document.getElementById(index);
      if (element) {
        if (element.style.display === 'none') {
          element.style.display = 'block';
        } else {
          element.style.display = 'none';
        }
      }
    };

    return {
      hideShow

    }
  }
}
</script>

<style scoped>
button:hover {
  text-decoration: underline;
}
</style>
